import { defineStore } from 'pinia'
import { FPS, durationToFrames } from '../tracks/frame'

export const useTimelineStore = defineStore('timeline', {
  state: () => {
    const defaultFrameWidth = 0.1
    return {
      // 帧数
      fps: FPS,
      frameDuration: Math.floor(1000 / FPS),

      // 帧宽默认值
      defaultFrameWidth: defaultFrameWidth,
      // 帧宽
      frameWidth: defaultFrameWidth,
      scaleConfig: {
        max: 30,
        min: 0.1,
        step: 0.01,
      },
      // 吸附相关的配置
      adsorption: {
        enable: true,
        direction: {
          left: -1,
          right: -1,
        },
      },
    }
  },
  actions: {
    zoomIn() {
      const { step } = this.scaleConfig
      const value = step
      const frameWidth = this.frameWidth + value
      this.zoomTo(frameWidth)
    },
    zoomOut() {
      const { step } = this.scaleConfig
      const value = step
      const frameWidth = this.frameWidth - value
      this.zoomTo(frameWidth)
    },
    zoomTo(frameWidth: number) {
      frameWidth = Number(frameWidth.toFixed(2))
      const { min, max } = this.scaleConfig
      if (frameWidth > max) {
        this.frameWidth = max
      } else if (frameWidth < min) {
        this.frameWidth = min
      } else {
        this.frameWidth = frameWidth
      }
    },
    /**
     *  将时间按照比例关系转成宽度(px)
     * @param time 毫秒
     */
    timeToWidth(time: number) {
      // const { fps } = this
      // const second = parseInt(String(time / 1000), 10)
      // const ms = time % 1000
      // // 每帧的毫秒数
      // const msPerFrame = 1000 / fps
      // // 指定时间有多少帧
      // const f = ms / msPerFrame

      // // eslint-disable-next-line no-mixed-operators
      // const frames = second * fps + f
      const frames = durationToFrames(time, false)
      return this.framesToWidth(frames)
    },
    framesToWidth(frames: number) {
      return frames * this.frameWidth
    },

    widthToTime(segmentWidth: number) {
      const { frameWidth, fps } = this
      const frames = segmentWidth / frameWidth
      const second = parseInt(String(frames / fps), 10)
      // 不满1s的帧数
      const ms = ((frames % fps) / fps) * 1000

      // eslint-disable-next-line no-mixed-operators
      return Math.floor(second * 1000 + ms)
    },
  },
})
